export enum HistoricalDataFilter {
  '1M' = '1M',
  '3M' = '3M',
  '6M' = '6M',
  '12M' = '12M',
  'TOTAL' = 'TOTAL',
}
